import { render, staticRenderFns } from "./CareerTab.vue?vue&type=template&id=1128f584&"
import script from "./CareerTab.vue?vue&type=script&lang=js&"
export * from "./CareerTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports